<template>
  <div @click="durumGuncelle">
    <vs-chip v-if="VALUE == 'Aktif'" color="success"> {{ VALUE }} </vs-chip>
    <vs-chip v-else-if="VALUE == 'Iptal'" color="danger">
      {{ VALUE }}
    </vs-chip>
    <vs-chip v-else-if="VALUE == 'Tamamlandı'" color="warning">
      {{ VALUE }}
    </vs-chip>
    <div v-else></div>
    <b-modal
      ref="modal-tamamla"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Tamamla"
      size="md"
      hide-footer
    >
      <div style="min-height: 350px">
        <vs-card>
          <div>
            <b-form-group label="Gelen Tarih" label-for="item-name"
              ><b-form-datepicker
                id="gelenTarih"
                v-model="gelenTarih"
                size="md"
                local="en"
                class="mb-2"
                today-variant="success"
                placeholder="-"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }"
            /></b-form-group>
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <b-button
                style="background-color: #FF9F43; border-color:#FF9F43;"
                v-on:click="durumKaydet()"
                ><Icon
                  style="margin-right: 5px"
                  icon="material-symbols:done-all-rounded"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Gelen Ürünü Tamamla'"
                />Tamamla</b-button
              >
            </vs-row>
          </div>
        </vs-card>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import state from "../../../store/state";
import Store from "../../../store/store";
export default {
  data() {
    return {
      VALUE: "",
      gelenTarih: ""
    };
  },
  components: { Icon },
  created() {
    this.VALUE = this.params.value;
  },
  methods: {
    durumKaydet() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.gelenTarih == "") {
        vs.notify({
          title: "Tedarikçi",
          text: "Tedarikçi Gelen Tarih Alanı Boş Olamaz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        const args = {
          durum: "Tamamlandı",
          gelenTarih: vm.gelenTarih,
          orderNumber: this.params.data.orderNumber,
          orderId: this.params.data.orderId,
          tedarikciBarkod: this.params.data.tedarikciBarkod
        };

        soap.createClient(url, function(err, client) {
          client.xmlTedarikciEkle(args, function(err, result) {
            if (result.xmlTedarikciEkleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler2 = JSON.parse(result.xmlTedarikciEkleResult);
              vm.rowdata = vm.veriler2.jsonData;
              vm.siparisDurumGuncelle();
              vs.notify({
                title: "Tedarikçi",
                text: "Tedarikçi Gelen Ürün Tamamlandı",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              vm.$root.$emit("getTedarikciSiparisleri");
            } catch (error) {
              console.log(error);
              vs.notify({
                title: "Tedarikçi",
                text: "Tedarikçi Gelen Üründe Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    siparisDurumGuncelle() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazarYeri: "Ticimax",
        orderNumber: vm.params.data.orderNumber,
        sipDurum: "4"
      };

      soap.createClient(url, function(err, client) {
        client.siparisDurumGuncelle(args, function(err, result) {
          if (result.siparisDurumGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler2 = JSON.parse(result.siparisDurumGuncelleResult);
            vs.notify({
              title: "Tedarikçi",
              text: "Durum güncellemesi başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            console.log(error);
            vs.notify({
              title: "Tedarikçi",
              text: "Durum güncellemesinde hata oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    durumGuncelle() {
      this.$refs["modal-tamamla"].show();
    }
  }
};
</script>

<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
